<template>
  <div>
      <h3 style="margin-bottom: 20px;">报名信息</h3>
      <div v-for="item in arr" :key="item.code" style="margin: 10px 0;">
        <div v-if="item.code === 'title'">
          <span class="label">{{item.value}}</span>
          <span>{{item.content | titleFilter}}</span>
        </div>
        <div v-else-if="item.code === 'discipline'">
          <span class="label">{{item.value}}</span>
          <span>{{item.content | subjectFilter(subjectsOptions)}}</span>
        </div>
        <div v-else-if="item.code === 'native'">
          <span class="label">{{item.value}}</span>
          <span>{{item.content | provinceFilter(provinceOptions) | cityFilter(cityOptions)}}</span>
        </div>
        <div v-else>
          <span class="label">{{item.value}}</span>
          <span>{{item.content === 'male' ? '男' : item.content === 'female' ? '女' : item.content}}</span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ["arr"],
  created() {
    this.getSubjectsOptions()
  },
  watch: {
    "arr": {
      deep: true,
      handler(newVla) {
        newVla.forEach(item => {
          if (item.code === 'native') {
            let arr = item.content.split(',')
            this.getProvinces()
            this.getCity(arr[0])
          }
        });
      },
    },
  },
  data() {
    return {
      subjectsOptions: [],
      provinceOptions: [],
      cityOptions: [],
    };
  },
  filters: {
    titleFilter(value) {
      let arr = ['正高级','副高级','中级','初级']
      let valueArr = value.split(',')
      return `${valueArr[1]}(${arr[valueArr[0]]})`
    },
    subjectFilter(value, options) {
      let valueArr = value.split(',')
      let str = ""
      options.forEach(item => {
        if (item.value === valueArr[0]) {
          item.children.forEach(i => {
            if (i.value === valueArr[1]) {
              str = `${item.label}/${i.label}`
            }
          })
        }
      });
      return str
    },
    provinceFilter(value, options) {
      let valueArr = value.split(',')
      let str = ""
      options.forEach(item => {
        if (item.code === valueArr[0]) {
           str = `${item.name}-${valueArr[1]}`
        }
      });
      return str
    },
    cityFilter(value, options) {
      let valueArr = value.split('-')
      let str = ""
      options.forEach(item => {
        if (item.code === valueArr[1]) {
          str = `${valueArr[0]}-${item.name}`
        }
      });
      return str
    }

  },
  methods: {
    // 获取学科领域下拉数据
    async getSubjectsOptions() {
      const { data } = await this.$apis.userServe.getRelationList();
      this.subjectsOptions = [...data];
    },
    
    // 获取省份下拉列表
    async getProvinces() {
      const { content } = await this.$apis.userServe.proList();
      this.provinceOptions = [...content.provinceList];
    },
    // 获取城市下拉列表
    async getCity(query) {
      const { content } = await this.$apis.userServe.cityList({
        provinceCode: query,
      });
      this.cityOptions = [...content.cityList];
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
    display: inline-block;
    margin-right: 20px;
    width: 80px;
}
</style>